import o from"./index.module.scss.js";const s=o;export{s as GridTheme};
//# sourceMappingURL=index.js.map
